import React, {Component}                                                                   from "react";
import {Image, ImageBackground, Platform, SafeAreaView, ScrollView, Text, TextInput, View}  from "react-native";
import NumericInput                                                                         from "react-native-numeric-input";
import {connect}                                                                            from "react-redux";
import Button                                                                               from "../Button";
import * as Actions                                                                         from "../../constants/Actions";
import * as Screens                                                                         from "../../constants/Screens";
import styles                                                                               from "../../styles/Styles";

class ScreenSettingsPlayer extends Component {
    takePhoto = (index) => {
        this.props.setPhotoIndex(index);
        this.props.changeScreen(Screens.CAMERA);
    }

    render() {
        var numPlayers = null;
        if (this.props.numPlayers > 1) {
            numPlayers =  
                <View key={0} style={styles.viewSettingsRow}>
                    <Text style={styles.textSetting}>Number of Players</Text>
                    <NumericInput borderColor="black" iconSize={10} maxValue={4} minValue={2} 
                        onChange={(value) => {this.props.setNumPlayers(value)}} rounded type="up-down" 
                        upDownButtonsBackgroundColor="yellow" value={this.props.numPlayers} />
                </View>;
        }

        //Player display
        var players = this.props.players.map((player, index) => {
            var button  = null;
            var image   = null;
            var style   = styles.viewSettingsRowWeb;
            if (Platform.OS !== "web") {
                button  = <Button onPress={() => {this.takePhoto(index)}} text="Photo" />;
                image   = <Image source={{uri: "data:image/png;base64," + player.icon}} style={styles.playerIconSelected} />;
                style   = styles.viewSettingsRow;
            }

            return  <View key={"player_" + index} style={style}>
                        <TextInput maxLength={12} onChangeText={text => this.props.setPlayerName(index, text)} style={styles.textInput} value={player.name}/>
                        {image}
                        {button}
                    </View>;
        });

        var playerDisplay = null;
        if (this.props.numPlayers > 1) {
            playerDisplay = 
                <SafeAreaView style={styles.viewSettingsDisplayPlayers}>
                    <ScrollView>
                        {players}
                    </ScrollView>
                </SafeAreaView>;
        }
        else playerDisplay = players;

        return (
            <View style={styles.background}>
                <ImageBackground source={require("../../../assets/screen_settings.png")} style={styles.background} imageStyle={styles.backgroundImageScreen}>
                    <View style={styles.viewSettingsScreen}>
                        <Text style={styles.textTitle}>SETTINGS</Text>

                        <View style={styles.viewSettingsDisplay}>
                            
                            {numPlayers}

                            <Text style={styles.textSetting}>Player Names</Text>
                            {playerDisplay}

                            <View style={styles.menuHorz}>
                                <Button onPress={() => {this.props.changeScreen(Screens.TITLE)}} text="Exit" />
                                <Button onPress={() => {this.props.changeScreen(Screens.CATEGORY)}} text="Enter" />
                            </View>
                        </View>
                    </View>
                </ImageBackground>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        numPlayers: state.numPlayers,
        players:    state.players
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   (screen)        => { dispatch({type: Actions.CHANGE_SCREEN,     screen:     screen}) },
        setNumPlayers:  (numPlayers)    => { dispatch({type: Actions.SET_NUM_PLAYERS,   numPlayers: numPlayers, screen: Screens.SETTINGS_PLAYER}) },
        setPhotoIndex:  (index)         => { dispatch({type: Actions.SET_PHOTO_INDEX,   index:      index})},
        setPlayerName:  (index, name)   => { dispatch({type: Actions.SET_PLAYER_NAME,   index:      index,      name:   name}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSettingsPlayer);